import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Dialog,
  Tooltip,
} from '@mui/material';
import { Edit } from '@mui/icons-material';
import { useMemo, useState } from 'react';
import useAppStore from 'store/useAppStore';
import ScriptEditorDialog from './ScriptEditorDialog';
import FullScriptEditorDialog from './FullScriptEditorDialog';
import api from 'services/api';
import getAllSegScriptForApi from 'utils/getAllSegScriptForApi';
import _fullChart from '_fullChart';
import Chart from './Chart';
import axios from 'axios';
import { produce } from 'immer';
import { DateTime } from 'luxon';

export default function GlobalScriptFlowCard() {
  const readOnly = useAppStore((state) => state.selectedProject.readOnly);
  const materialDevices = useAppStore((state) => state.materialDevices);
  const stations = useAppStore((state) => state.stations);
  const scripts = useAppStore((state) => state.scripts);
  const showNotification = useAppStore((state) => state.showNotification);
  const hasFullScript = useAppStore((state) => state.editedFullScript !== '');

  // 腳本編輯器狀態
  const [scriptEditorOpen, setScriptEditorOpen] = useState(false);
  const [selectedScriptIndex, setSelectedScriptIndex] = useState(null);

  // 全局腳本編輯器狀態
  const [fullScriptEditorOpen, setFullScriptEditorOpen] = useState(false);

  // 處理腳本節點點擊
  const handleScriptClick = async (index) => {
    setSelectedScriptIndex(index);
    setScriptEditorOpen(true);
  };

  // 關閉腳本編輯器
  const handleCloseScriptEditor = () => {
    setScriptEditorOpen(false);
  };

  // 檢查所有腳本是否都有 segScript
  const allScriptsHaveSegScript = useMemo(() => {
    return scripts.length > 0 && scripts.every((script) => script.segScript);
  }, [scripts]);

  const handleEditGlobalScript = () => {
    setFullScriptEditorOpen(true);
  };

  // 關閉全局腳本編輯器
  const handleCloseFullScriptEditor = () => {
    setFullScriptEditorOpen(false);
  };

  const [projectCreation, { isLoading: projectCreationLoading }] =
    api.endpoints.projectCreation.useMutation();
  const [projectTempSave, { isLoading: projectTempSaveLoading }] =
    api.endpoints.projectTempSave.useMutation();

  const tempSave = async () => {
    // projectTempSave();
    const selectedProject = useAppStore.getState().selectedProject;
    const project_id = selectedProject.project_id;
    const project_name = selectedProject.project_name;
    const related_project_id = useAppStore.getState().selectedRelatedProject;
    const ori_project_id = selectedProject.ori_project_id;
    const user = useAppStore.getState().user;

    const formData = new FormData();
    formData.append('user_id', user.id || '');
    formData.append('comp_name', user.company || '');
    formData.append('industry', user.industry);
    formData.append('project_id', project_id);
    formData.append('project_name', project_name);
    // 添加檔案
    if (selectedProject.ori_project_id === '') {
      // 新增
      selectedProject.files.forEach((file) => {
        formData.append('file_list', file);
      });
    } else {
      // 從資料庫選擇
      const fileBlobs = await Promise.all(
        selectedProject.files.map(async (fileName) => {
          const { data: blob } = await axios.post(
            'https://140.96.111.8:8516/api/getFileObject/',
            {
              comp_name: user.company,
              project_id: selectedProject.ori_project_id,
              file_name: fileName,
            },
            {
              responseType: 'blob',
            },
          );
          return new File([blob], fileName, { type: blob.type });
        }),
      );
      fileBlobs.forEach((file) => {
        formData.append('file_list', file);
      });
    }
    formData.append(
      'hand_transp',
      JSON.stringify(
        materialDevices.map((item) =>
          produce(item, (draft) => {
            delete draft.id;
          }),
        ),
      ),
    );
    formData.append(
      'station',
      JSON.stringify(
        stations.map((item) =>
          produce(item, (draft) => {
            delete draft.id;
          }),
        ),
      ),
    );
    formData.append('seg_script', JSON.stringify(getAllSegScriptForApi()));
    formData.append(
      'related_project_id',
      JSON.stringify(Object.keys(related_project_id)),
    );
    formData.append('ori_project_id', ori_project_id);
    formData.append(
      'edit_time',
      DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss'),
    );
    projectTempSave(formData)
      .unwrap()
      .then(() => {
        showNotification('專案暫存成功', 'success');
      })
      .catch((error) => {
        if (error.message) {
          showNotification(error.message, 'error');
        } else {
          showNotification('專案暫存失敗', 'error');
        }
      });
  };

  const doneProject = async () => {
    try {
      const selectedProject = useAppStore.getState().selectedProject;
      const project_id = selectedProject.project_id;
      const project_name = selectedProject.project_name;
      const related_project_id = useAppStore.getState().selectedRelatedProject;
      const ori_project_id = selectedProject.ori_project_id;
      const user = useAppStore.getState().user;

      const formData = new FormData();
      formData.append('user_id', user.id || '');
      formData.append('comp_name', user.company || '');
      formData.append('industry', user.industry);
      formData.append('project_id', project_id);
      formData.append('project_name', project_name);
      // 添加檔案
      if (selectedProject.ori_project_id === '') {
        // 新增
        selectedProject.files.forEach((file) => {
          formData.append('file_list', file);
        });
      } else {
        // 從資料庫選擇
        const fileBlobs = await Promise.all(
          selectedProject.files.map(async (fileName) => {
            const { data: blob } = await axios.post(
              'https://140.96.111.8:8516/api/getFileObject/',
              {
                comp_name: user.company,
                project_id: selectedProject.ori_project_id,
                file_name: fileName,
              },
              {
                responseType: 'blob',
              },
            );
            return new File([blob], fileName, { type: blob.type });
          }),
        );
        fileBlobs.forEach((file) => {
          formData.append('file_list', file);
        });
      }
      formData.append(
        'hand_transp',
        JSON.stringify(
          materialDevices.map((item) =>
            produce(item, (draft) => {
              delete draft.id;
            }),
          ),
        ),
      );
      formData.append(
        'station',
        JSON.stringify(
          stations.map((item) =>
            produce(item, (draft) => {
              delete draft.id;
            }),
          ),
        ),
      );
      formData.append('seg_script', JSON.stringify(getAllSegScriptForApi()));
      formData.append(
        'related_project_id',
        JSON.stringify(Object.keys(related_project_id)),
      );
      formData.append('ori_project_id', ori_project_id);

      projectCreation(formData)
        .unwrap()
        .then(() => {
          showNotification('專案新增成功', 'success');
        })
        .catch((error) => {
          if (error.message) {
            showNotification(error.message, 'error');
          } else {
            showNotification('專案新增失敗', 'error');
          }
        });
    } catch (error) {
      console.error('error', error);
      showNotification('專案新增失敗', 'error');
    }
  };

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            全局腳本流程
          </Typography>
          <Tooltip
            title={
              allScriptsHaveSegScript || readOnly
                ? undefined
                : '請先為所有腳本生成區段腳本'
            }
          >
            <span>
              <Button
                variant="contained"
                startIcon={<Edit />}
                size="small"
                disabled={readOnly === false && !allScriptsHaveSegScript}
                onClick={handleEditGlobalScript}
              >
                {readOnly ? '查看全局腳本' : '編輯全局腳本'}
              </Button>
            </span>
          </Tooltip>
        </Box>

        {/* SVG 動態流程圖 */}
        <Box
          sx={{
            minHeight: 500,
            maxWidth: '100%',
            overflow: 'auto',
          }}
        >
          <Chart handleScriptClick={handleScriptClick} />
        </Box>

        {/* 看不到的 SVG 動態流程圖 (給pdf抓) */}
        <div className="invisible absolute -z-50 w-0 h-0">
          <div
            ref={_fullChart}
            className="max-w-full flex justify-center items-center"
          >
            <Chart />
          </div>
        </div>
        {readOnly === false && (
          <div className="flex gap-2 justify-end">
            <Button
              loading={projectTempSaveLoading}
              className="self-end"
              variant="contained"
              onClick={tempSave}
            >
              暫存專案
            </Button>
            <Button
              loading={projectCreationLoading}
              className="self-end"
              variant="contained"
              disabled={!hasFullScript}
              onClick={doneProject}
            >
              完成專案
            </Button>
          </div>
        )}

        {/* 腳本編輯器彈窗 */}
        <Dialog
          open={scriptEditorOpen}
          onClose={handleCloseScriptEditor}
          maxWidth={false}
          fullWidth
          classes={{
            paper: 'h-full',
          }}
        >
          <ScriptEditorDialog
            onClose={handleCloseScriptEditor}
            scriptIndex={selectedScriptIndex}
          />
        </Dialog>

        {/* 全局腳本編輯器彈窗 */}
        <Dialog
          open={fullScriptEditorOpen}
          onClose={handleCloseFullScriptEditor}
          maxWidth={false}
          fullWidth
          classes={{
            paper: 'h-full',
          }}
        >
          <FullScriptEditorDialog
            open={fullScriptEditorOpen}
            onClose={handleCloseFullScriptEditor}
          />
        </Dialog>
      </CardContent>
    </Card>
  );
}
